<template>
  <v-container fluid v-if="user != null">
    <v-layout row wrap>
      <user-edit-fields v-model="user" type="add"></user-edit-fields>
    </v-layout>
  </v-container>
</template>
<script>
import UserEditFields from '@/components/UserEditFields.vue';

export default {
  name: 'UserAddView',
  components: { UserEditFields },
  computed: {
    user: {
      get() {
        return {
        };
      },
      set(value) {
        this.$store.commit('createUser', value);
        this.$router.push({ name: 'Users' });
      },
    },
  },
};
</script>
